namespace Nobox {
    export interface ChatroomsRow {
        Id?: number;
        St?: number;
        IsGrp?: number;
        GrpId?: number;
        FormTemplateId?: number;
        FormResultId?: number;
        Grp?: string;
        GrpExtId?: string;
        IsPin?: number;
        TagsIds?: string;
        Tags?: string;
        FnId?: number;
        Fn?: string;
        DealId?: number;
        Deal?: string;
        CampaignId?: number;
        Campaign?: string;
        CtId?: number;
        CtRealId?: number;
        LinkImg?: string;
        Ct?: string;
        CtRealNm?: string;
        CtImg?: string;
        CtIsBlock?: number;
        CtIdExt?: string;
        ChAccAlias?: string;
        ChId?: number;
        Ch?: string;
        ChAccId?: number;
        ChAcc?: string;
        AccChId?: string;
        AccData?: string;
        LastMsg?: string;
        SdrMsg?: string;
        Uc?: number;
        ReAt?: string;
        ReById?: number;
        ReByNm?: string;
        TimeResolved?: string;
        TimeArchived?: string;
        IsBlock?: number;
        IsAutoResolve?: number;
        IsAutoArchive?: number;
        In?: string;
        RoomAgent?: ChatroomagentsRow[];
        AgentIds?: string;
        StNm?: string;
        InBy?: number;
        Up?: string;
        TimeMsg?: string;
        UpBy?: number;
    }

    export namespace ChatroomsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'St';
        export const localTextPrefix = 'Chat.Chatrooms';
        export const lookupKey = 'Chat.Chatrooms';

        export function getLookup(): Q.Lookup<ChatroomsRow> {
            return Q.getLookup<ChatroomsRow>('Chat.Chatrooms');
        }
        export const deletePermission = 'ChatRoom:Delete';
        export const insertPermission = 'ChatRoom:Modify';
        export const readPermission = 'ChatRoom:View';
        export const updatePermission = 'ChatRoom:Modify';

        export declare const enum Fields {
            Id = "Id",
            St = "St",
            IsGrp = "IsGrp",
            GrpId = "GrpId",
            FormTemplateId = "FormTemplateId",
            FormResultId = "FormResultId",
            Grp = "Grp",
            GrpExtId = "GrpExtId",
            IsPin = "IsPin",
            TagsIds = "TagsIds",
            Tags = "Tags",
            FnId = "FnId",
            Fn = "Fn",
            DealId = "DealId",
            Deal = "Deal",
            CampaignId = "CampaignId",
            Campaign = "Campaign",
            CtId = "CtId",
            CtRealId = "CtRealId",
            LinkImg = "LinkImg",
            Ct = "Ct",
            CtRealNm = "CtRealNm",
            CtImg = "CtImg",
            CtIsBlock = "CtIsBlock",
            CtIdExt = "CtIdExt",
            ChAccAlias = "ChAccAlias",
            ChId = "ChId",
            Ch = "Ch",
            ChAccId = "ChAccId",
            ChAcc = "ChAcc",
            AccChId = "AccChId",
            AccData = "AccData",
            LastMsg = "LastMsg",
            SdrMsg = "SdrMsg",
            Uc = "Uc",
            ReAt = "ReAt",
            ReById = "ReById",
            ReByNm = "ReByNm",
            TimeResolved = "TimeResolved",
            TimeArchived = "TimeArchived",
            IsBlock = "IsBlock",
            IsAutoResolve = "IsAutoResolve",
            IsAutoArchive = "IsAutoArchive",
            In = "In",
            RoomAgent = "RoomAgent",
            AgentIds = "AgentIds",
            StNm = "StNm",
            InBy = "InBy",
            Up = "Up",
            TimeMsg = "TimeMsg",
            UpBy = "UpBy"
        }
    }
}
